<template>
    <div class="page-container">
        <van-nav-bar title="退款详情" fixed left-arrow @click-left="goableBack()"></van-nav-bar>
        <div class="page">
            <div v-if="order.status==30" class="px-20 pt-10">
                <div class="fs-16">请等待商家处理</div>
                <div class="mt-5 color-gray-dark">您已成功发起退款,请耐心等待商家处理</div>
            </div>
            <div v-if="order.status==31" class="px-20">
                <div class="fs-16">商家已处理完成</div>
            </div>
            <div class="mt-10 p-20 bg-color-white product">
                <div>退款信息</div>
                <div class="flex-row flex-a-c">
                    <div class="left mr-20">
                        <img :src="order.coverImg">
                    </div>
                    <div class="right">
                        <div class="mt-10 flex-row flex-j-sb flex-a-c">
                            <div class="fs-16">{{order.title}}</div>
                            <div class="color-red ml-10">{{status}}</div>
                        </div>
                        <div class="fs-12 mt-5 color-gray-dark">{{order.des}}</div>
                        <div class="mt-10 flex-row flex-j-sb flex-a-c">
                            <div class="fs-16">¥{{order.price}} <span class="fs-14 color-gray-dark ml-10">x{{order.num}}</span></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-10 bg-color-white p-20 info">

                <div class="mt-10 ml-10 color-gray-dark">退款原因: {{order.id}}</div>
                <div class="mt-5 ml-10 color-gray-dark">退款金额: {{order.createTime}}</div>
                <div class="mt-5 ml-10 color-gray-dark">申请时间: {{order.payTime}}</div>
                <div class="mt-5 ml-10 color-gray-dark">退款编号: {{order.id}}</div>
            </div>
        </div>

    </div>

</template>

<script>
    import {Cell, NavBar, Button, Toast, } from "vant";
    import * as GoodsApi from '@/api/goods';

    export default {
        name: "order-view",
        data: () => ({
            order:{},
        }),
        beforeRouteEnter(to, from, next) {
            GoodsApi.getOrder(to.params.id).then(data=>{
                next(vm => {
                    vm.setData(data);
                })
            })

        },
        beforeRouteUpdate (to, from, next) {
            GoodsApi.getOrder(to.params.id).then(data=>{
                this.setData(data);
                next();
            });
        },
        computed:{

            status:function () {
                let statusMap = {
                    0:"待付款",
                    10:"待发货",
                    11:"待收货",
                    12:"已完成",
                    30:"退货中",
                    31:"已退款",
                    20:"已取消"
                };
                return statusMap[this.order.status];
            }
        },
        methods: {
            setData(data) {
                this.order = data;
            },

        },
        components: {
            [Cell.name]: Cell,
            [NavBar.name]: NavBar,
            [Button.name]: Button,
            [Toast.name]: Toast ,
        },
    }
</script>

<style lang="less" scoped>
    .page-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin: 0;
        box-sizing: border-box;
    }

    .address {
        .left-icon {
            width: 30px;
            height: auto;
        }

        .van-cell__value {

        }
    }

    .product {
        .left {
            width: 25vw;
            img {
                width: 100%;
                height: auto;
            }
        }
        .right {
            flex: 1;
        }
    }

    .total {
        font-size: 18px;
        .van-cell__value {
            color: #323233;
        }
    }
    .info {

    }

</style>